<template>
  <div class="sidebar-container">
    <div v-if="hamburger" class="sidebar-hamburger flexCC mt-12">
      <cnd-icon
        :name="isCollapse ? 'cnd-menu-shrink' : 'cnd-menu-unfold'"
        @click="toggleHamburger"
      />
    </div>
    <div class="sidebar-wrapper">
      <el-scrollbar :native="isCollapse" :wrap-class="['scrollbar-banner']">
        <el-menu
          mode="vertical"
          :collapse="isCollapse"
          :default-active="$route.meta.id"
          :default-openeds="defaultOpeneds"
          :unique-opened="uniqueOpen"
          menu-trigger="click"
          :collapse-transition="collapseTransition"
        >
          <template  v-for="item in allMenu">
            <sidebar-item
              v-if="!item.hidden"
              :key="item.meta.id"
              :is-collapse="isCollapse"
              :item="item"
              :link-props="linkProps"
              :base-path="item.path"
            />
          </template>
        </el-menu>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import SidebarItem from './SidebarItem'

export default {
  name: 'Sidebar',
  components: { SidebarItem },
  props: {
    // 是否显示汉堡图标
    hamburger: {
      type: Boolean,
      default: false
    },
    // 是否展开
    isCollapse: {
      type: Boolean,
      default: false
    },
    // 是否只保持一个子菜单的展开
    uniqueOpen: {
      type: Boolean,
      default: true
    },
    // 是否开启折叠动画
    collapseTransition: {
      type: Boolean,
      default: false
    },
    // variables: {
    //   type: Object,
    //   default: () => {
    //     return {}
    //   }
    // },
    // 全部菜单
    allMenu: {
      type: Array,
      default: () => []
    },
    // 外部链接参数
    linkProps: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      defaultOpeneds: []
      // variablesDefault: {}
    }
  },
  // computed: {
  //   _variables() {
  //     return Object.assign(this.variablesDefault, this.variables)
  //   }
  // },
  methods: {
    toggleHamburger() {
      this.$emit('toggleHamburger')
    }
  }
}
</script>

<style lang="scss">
// @import "../../../../lib/styles/variables.scss";
@import "../../../../lib/styles/components/SideBar.scss";
</style>
